export default __webpack_public_path__ + "static/media/Show-documentation.40892bc2.md";